function getEnv() {
  if (typeof process !== 'undefined' && process.env.NODE_ENV) {
    return process.env.NODE_ENV
  }
  return 'development'
}

function isEnv(env: string) {
  return getEnv() === env
}

export function isDevelopment() {
  return isEnv('development')
}

export function isProduction() {
  return isEnv('production')
}
